module.exports = __webpack_public_path__ + "img/systemx_MAIN_Colour_Black.eff510e7.svg";